<section class="bg-light p-3 rounded">
  <h3 class="text-center mb-3">Template-Driven Form</h3>
  <form
    #dataForm="ngForm"
    novalidate
    (ngSubmit)="onSubmit(dataForm)">
    <div class="row mb-3">
      <div class="col-4">
        <label
          for="inputUsername"
          class="form-label"
          >Username</label
        >
      </div>
      <div class="col-8">
        <input
          required
          type="text"
          class="form-control"
          id="inputUsername"
          name="username"
          [(ngModel)]="modelData.username" />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-4">
        <label
          for="inputEmail"
          class="form-label"
          >Email</label
        >
      </div>
      <div class="col-8">
        <input
          required
          type="text"
          class="form-control"
          id="inputEmail"
          name="email"
          [(ngModel)]="modelData.email" />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-4">
        <label
          for="inputGender"
          class="form-label"
          >Gender</label
        >
      </div>
      <div class="col-8">
        <select
          required
          class="form-select"
          id="inputGender"
          name="gender"
          [(ngModel)]="modelData.gender">
          <option></option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-4"></div>
      <div class="col-8">
        <button
          type="submit"
          class="btn btn-primary btn-lg"
          [disabled]="dataForm.form.invalid">
          Submit
        </button>
      </div>
    </div>
  </form>

  <pre>{{ modelData | json }}</pre>
</section>
